<div>

      <div class="shadowBox row">
        <div class="col-sm-12">
          <h4 style="font-weight: bold;color: darkblue;padding: 0px;margin-bottom: 0px;">{{endpoint_data.system_name}} : <a (click)="goToLink(endpoint_data)" style="cursor:pointer;text-decoration: underline;">{{endpoint_data.system_ip}}</a></h4>
        </div>
        <div class="col-sm-5" style="margin: 0px; padding: 0px;">
          <br>
          <p style="font-weight: bold;">System State:</p>
          <p style="font-weight: bold;">Last Health Check Date:</p>
          <p style="font-weight: bold;">Up Time:</p>
          <p style="font-weight: bold;">Last Active Date:</p>
          <p style="font-weight: bold;">Provisioning State:</p>
          <p style="font-weight: bold;">Monitoring State:</p>
          <p style="font-weight: bold;">Notes:</p>

        </div>

        <div class="col-sm-6"  style="margin: 0px; padding: 0px;">
          <br>
          <p style="font-weight: bold;" [style.color]="returnElementColor(endpoint_data)">{{endpoint_data.status?endpoint_data.status:"Relay-Unit connection error"}}</p>
          <p>{{endpoint_data.last_monitored_date?endpoint_data.last_monitored_date:"NA"}}</p>
          <p>{{endpoint_data.last_up_time?(endpoint_data.last_down_time?Math.ceil(Math.abs(currentDate.getTime() - lastDownDate) / 60000)+" minutes":"NA"):"NA"}}</p>
          <p>{{endpoint_data.last_up_time?endpoint_data.last_up_time:"NA"}}</p>
          <p [ngStyle]="{'color': (endpoint_data.is_provisioned==1) ? '#008000' : '#FF0000'}">{{endpoint_data.is_provisioned==1?"System is provisioned by VMS":"VMS is not provisioning this system"}}</p>
          <p [ngStyle]="{'color': (endpoint_data.is_monitored==1) ? '#008000' : '#FF0000'}">{{endpoint_data.is_monitored==1?"System is monitored by VMS":"VMS is not monitoring this system"}}</p>
          <p style="word-break: break-all;white-space: normal;">{{endpoint_data.ops_note?endpoint_data.ops_note:"No notes were placed on this unit."}}</p>

        </div>

      </div>


  <div class="text-center mt-2" id="actions">
      <div class="dropdown">
        <button mat-raised-button  color="primary"  class="m-1"
         type="button" id="dropdownMenuButton" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          Actions
          <mat-icon aria-hidden="false">more_vert</mat-icon>
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">

          <button mat-raised-button  color="primary" class="dropdown-item"
              *ngIf="endpoint_data.is_provisioned==0" [disabled]="provisionProcessFlag">
            <span style="margin: 0px;padding: 0px;"  (click)="openDialogProvision()">Provision Unit</span>
          </button>

          <button mat-raised-button  color="warn" class="dropdown-item" [disabled]="provisionProcessFlag"
                 *ngIf="endpoint_data.is_provisioned==1" (click)="openDialogUnprovision()">
            <span style="margin: 0px;padding: 0px;">Unprovision Unit</span>
          </button>

          <button mat-raised-button color="primary" *ngIf="adminAuthorization" [disabled]="systemMarketLocationData?.market_name=='Not Supported' "
                         class="dropdown-item" >
              <span style="margin: 0px;padding: 0px;" (click)="openDialogMonitor()" >
                {{endpoint_data.is_monitored==1?"Stop monitoring":"Start monitoring"}}
              </span>
          </button>

          <button mat-raised-button  style=" background-color: lightgray;" class="dropdown-item"
                        (click)="openAddNoteDialog()" >
                  <mat-icon aria-hidden="false" aria-label="add"
                                style="font-size: 16px !important; margin: 0px; padding: 0px;">add</mat-icon>
                  <span [ngStyle]="{'color':  '#0000FF' }">Add note</span>
          </button>
          <!-- || endpoint_data.software_version==null || endpoint_data.software_version?.toLocaleLowerCase().includes('f9') -->
          <div *ngIf="adminAuthorization">
            <button mat-raised-button  color="primary"
            [disabled]="!endpoint_data.is_provisioned" (click)="openRollbackDialog()"
                       class="dropdown-item">
                <mat-icon aria-hidden="false" aria-label="add"
                                  style="font-size: 16px !important;  margin: 0px; padding: 0px;">
                                  settings
                </mat-icon>
                <span >Rollback Config.</span>
            </button>
          </div>

          <div *ngIf="adminAuthorization">
          <button mat-raised-button  color="primary"
                      [disabled]="!endpoint_data.is_provisioned"
                     (click)="openBackupDialog()" class="dropdown-item">
              <mat-icon aria-hidden="false" aria-label="add" >
                                backup
              </mat-icon>
              <span>Backup System Files</span>
          </button>
        </div>

        <div *ngIf="adminAuthorization">
          <button mat-raised-button  color="warn"
                         [disabled]="!endpoint_data.is_provisioned"
                     (click)="openRemoveBackupDialog()" class="dropdown-item">
              <mat-icon aria-hidden="false" aria-label="add">
                                delete_forever
              </mat-icon>
              <span>Remove All Backups</span>
          </button>
        </div>


      </div>
  </div>

  <div style="display: inline;margin: 0px;padding: 0px;">

  <!-- <p class="errText" *ngIf="!endpoint_data.is_provisioned">* Adding notes is disabled for unprovisioned units</p> -->
  <p class="errText" *ngIf="!endpoint_data.is_provisioned">* Rollback is disabled for unprovisioned units</p>
  <p class="errText" *ngIf="!endpoint_data.system_password">* This system does not have a password</p>
  <p class="errText" *ngIf="!endpoint_data.is_monitored">* This system is not monitored by VMS</p>
  <!-- <p class="errText" *ngIf="endpoint_data.software_version==null || endpoint_data.software_version?.toLocaleLowerCase().includes('f9')">* Rollback is disabled for unit due to legacy software version, please upgrade to enable it. </p> -->
  </div>



</div>
